import type { HsSubscriberData } from '../types/subscriber-data.type';
import type { HsSubscriberFunction } from '../types/subscriber-function.type';
import { HsSubject } from './subject.class';

export class HsBehaviorSubject<T> extends HsSubject<T> {
  protected readonly subscribers: Set<HsSubscriberFunction<T>> = new Set<HsSubscriberFunction<T>>();
  private value: T;
  constructor(value: T) {
    super();
    this.value = value;
  }
  public next(value: T): void {
    this.value = value;
    for (const subscriber of this.subscribers) {
      subscriber(this.value);
    }
  }
  public subscribe(subscriber: HsSubscriberFunction<T>): HsSubscriberData<T> {
    this.subscribers.add(subscriber);
    subscriber(this.value);
    return [this, subscriber];
  }
}
